import moment from './moment'

/**
 * Format date to Hours format: "07:00"
 * @param {String} date
 * @param {String} dateFormat
 */
export default (date, dateFormat) =>
  moment(date, dateFormat, true).format('HH:mm')
